import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FriendlyString',
  props: {
  value: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'unknown',
  },
},
  setup(__props) {

const props = __props;

const formattedValue = computed(() => {
  if (isUnknown.value) {
    return props.placeholder;
  }

  return props.value;
});

const isUnknown = computed(() => !props.value || props.value.trim().length === 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({ 'is-unknown': isUnknown.value })
  }, _toDisplayString(formattedValue.value), 3))
}
}

})